<template>
  <p-dialog
    :value="selectedUpgrade ? true : false"
    @input="selectUpgrade(false)"
    min-height="650px"
    max-height="800px"
    max-width="800px"
  >
    <template #toolbar>
      <v-toolbar-title> <v-icon left>mdi-update</v-icon>Update Content </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="selectUpgrade(false)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <v-toolbar flat class="transparent">
      <v-toolbar-items class="hidden-sm-and-down">
        <content-type-icon :type="selectedUpgrade.dependent.header.content_revision_type" />
      </v-toolbar-items>
      <v-toolbar-title>
        <span class="caption">
          <v-chip small label dark>
            <v-icon small>mdi-library-shelves</v-icon>
            {{ selectedUpgrade.dependent.library.name }}
          </v-chip>
          <v-chip small label dark>
            <v-icon small>mdi-tag</v-icon>
            {{ selectedUpgrade.dependent.header.custom_id }}
          </v-chip>
        </span>
        <br />
        {{ selectedUpgrade.dependent.header.metadata.title }} (Rev
        {{ selectedUpgrade.dependent.header.major_revision }}.{{ selectedUpgrade.dependent.header.minor_revision }})
      </v-toolbar-title>
    </v-toolbar>
    <h3 class="headline mt-4 mb-2">Outdated Dependencies</h3>
    <p>
      The following contents are used inside "{{ selectedUpgrade.dependent.header.metadata.title }}" (Rev
      {{ selectedUpgrade.dependent.header.major_revision }}.{{ selectedUpgrade.dependent.header.minor_revision }}) and
      have been updated to a newer revision. Click update to update "{{
        selectedUpgrade.dependent.header.metadata.title
      }}" to use the latest revisions.
    </p>
    <v-data-table :headers="headers" :items="selectedUpgrade.outdated">
      <template v-slot:items="props">
        <slot>
          <tr style="cursor: pointer">
            <td>
              <v-icon small left>mdi-library-shelves</v-icon>
              {{ props.item.library.name }}
            </td>
            <td>
              <content-type-icon :type="props.item.header.content_revision_type" />
            </td>
            <td>{{ props.item.latest.custom_id }}</td>
            <td>{{ props.item.latest.metadata.title }}</td>
            <td>{{ props.item.header.major_revision }}.{{ props.item.header.minor_revision }}</td>
            <td>{{ props.item.latest.major_revision }}.{{ props.item.latest.minor_revision }}</td>
          </tr>
        </slot>
      </template>
    </v-data-table>
    <template #actions>
      <v-btn color="success" outline @click="updateSelectedDependents(approve)">
        <v-icon left>mdi-update</v-icon>Update
      </v-btn>
      <v-checkbox v-model="approve" class="ml-2" label="Approve after update (minor revision)"></v-checkbox>
      <v-spacer></v-spacer>
      <v-btn @click="selectUpgrade(false)" flat color="red">cancel</v-btn>
    </template>
  </p-dialog>
</template>

<script>
import { PDialog, ContentTypeIcon } from "plant-common"
import { selectedUpgrade, selectUpgrade, updateSelectedDependents } from "../store"
import ContentCardSmall from "./ContentCardSmall.vue"

export default {
  props: ["header"],
  components: { PDialog, ContentCardSmall, ContentTypeIcon, ContentTypeIcon },
  data() {
    return {
      approve: false,
      headers: [
        {
          text: "library",
          value: "library.name",
          width: "30px"
        },
        {
          text: "Type",
          value: "header.content_revision_type",
          width: "30px"
        },
        {
          text: "Custom Id",
          value: "header.custom_id",
          width: "20%"
        },
        {
          text: "Title",
          value: "header.metadata.title",
          width: "80%"
        },
        {
          text: "Current",
          width: "10em",
          sortable: false
        },
        {
          text: "Latest",
          width: "10em",
          sortable: false
        }
      ]
    }
  },
  computed: {
    selectedUpgrade
  },
  methods: {
    updateSelectedDependents,
    selectUpgrade
  }
}
</script>
